

function Transcription(){

}

export default Transcription;